<template>
    <!--
            作者：peng
            时间：2020-08-11
            描述：插件中心-高级签到-签到设置
        -->
    <div class="product-add pb50" v-loading="loading">
        <div>
            <div class="common-form">选择商品</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" class="demo-form-inline">
                    <el-form-item label="*选择商品 " prop="product">
                        <el-form-item>
                            <el-input v-model="productID" placeholder="请输入商品ID"></el-input>
                        </el-form-item>
                        <!--<el-button @click="openConpon" icon="el-icon-plus">选择商品</el-button>-->
                        <el-form-item>
                            <el-button icon="el-icon-plus" @click="onSubmit">加入</el-button>
                        </el-form-item>
                        <p>注：没填写天数的商品不能加入高级签到</p>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div>
            <div class="common-form">基础设置</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
                    <el-form-item label="帮助页面路径" prop="rules_url" style="display: block">
                        <el-form-item>
                            <el-input class="max-w460" v-model="form.rules_url" placeholder="请输入帮助页面路径" style="width: 500px"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="登录获取手机号" style="display: block;">
                        <el-radio-group v-model="form.is_phone" prop="is_phone">
                            <el-radio :label="0">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="gotoTrue()">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div>
            <div class="common-form">绑定商品列表</div>
            <div class="table-wrap">
                <el-table :data="putProductLists" style="width: 100%" v-loading="loading">
                    <el-table-column prop="product_id" label="商品ID" width="260"></el-table-column>
                    <el-table-column prop="product_name" label="商品名称" width="260"></el-table-column>
                    <el-table-column prop="product_name" label="商品有效期">
                        <template slot-scope="scope">
                            <div class="text-ellipsis">{{scope.row.product_days}}天</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button @click="removeBind(scope.row)" type="text" size="small">解除绑定</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--分页-->
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            background
                            :current-page="curPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :total="totalDataNumber"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <Getsignadv v-if="bounced"></Getsignadv>
    </div>
</template>

<script>
    import Getsignadv from '@/components/signadv/Getsignadv.vue';
    import SignadvApi from '@/api/signadv.js';
    export default {
        components: {
            Getsignadv,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: false,
                /* 是否显示商品选择弹框  */
                bounced:false,
                productID:'',
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                putProductLists:[],
                form:{
                    rules_url:'',
                    is_phone:1,
                },
            };
        },
        created() {
            this.putProductList();
            this.settingList();
        },
        methods: {
            openConpon(){
                console.log(111);
                let self = this;
                self.bounced = true
            },
            fatherClose(){
                let self = this;
                self.bounced = false
            },
            onSubmit(){
                let self = this;
                let Params = {};
                Params.product_id = self.productID;
                SignadvApi.putProduct(Params,true)
                    .then(data => {
                        self.loading = false;
                        this.$message({
                            type: 'success',
                            message: data.msg
                        });
                        self.putProductList();
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            putProductList(){
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                SignadvApi.putProductList(Params,true)
                    .then(data => {
                        console.log(data)
                        self.putProductLists = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            removeBind(row){
                let params = {};
                params.product_id = row.product_id;
                this.$confirm('此操作将取消商品绑定, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    SignadvApi.goRemove(params,true)
                        .then(data => {
                            console.log(data);
                            this.$message({
                                type: 'success',
                                message: data.msg
                            });
                            this.putProductList();
                        })
                        .catch(error => {
                            this.$message({
                                type: 'info',
                                message: error.msg
                            });
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.putProductList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.putProductList();
            },
            gotoTrue(){
                let self = this;
                let params = self.form;
                SignadvApi.putRules(params,true)
                    .then(data => {
                        if(data.code == 1){
                            self.$message({
                                message: '恭喜你，保存成功',
                                type: 'success'
                            });
                        }else {
                            self.loading = false;
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            settingList(){
                let self = this;
                SignadvApi.getSettingList('',true)
                    .then(data => {
                        self.form = data.data.list;
                        console.log(self.form)
                    })
                    .catch(error => {

                    });
            }
        }
    };
</script>

<style scoped="scoped">
    .select-user li{ width: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/plus/signadv/setting/setting.vue